<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <RadioMenu :menuIndex="menuIndex" :menu="menu" /> -->

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "VehicleList",
  data() {
    return {
      baseUrl: 'car',
      breadcrumb: [
        { name: "车辆管理" },
        { name: "车辆列表" },
      ],
      menu: [],
      menuIndex: '',
    };
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    getOptions() {
      this.post(`${this.baseUrl}/index`, {}, ({ team, carstatus, fleet, cartype }) => {
        if (team && team.length) {
          this.menu = team.map((v, i) => {
            return {
              name: v.nickname,
              path: `/vehicle/manage/table/${i + 1}`,
            }
          })
          const { idx } = this.$route.params
          this.menuIndex = `/vehicle/manage/table/${idx}`
          this.setState({
            key: 'carstatus',
            value: carstatus,
          })
          this.setState({
            key: 'cartype',
            value: cartype,
          })
          this.setState({
            key: 'fleet',
            value: fleet,
          })
        } else {
          this.$message({
            type: 'error',
            message: '请先创建车队',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions();
  },
};
</script>
